/**
=========================================================
* Soft UI Dashboard PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { forwardRef } from 'react';

// Custom styles for SuiButton
import SuiButtonRoot from './SuiButtonRoot';
import { Link } from 'react-router-dom';

const SuiButton = forwardRef(
    (
        {
            color,
            variant,
            size,
            circular,
            iconOnly,
            children,
            navigateTo,
            ...rest
        },
        ref,
    ) => (
        <SuiButtonRoot
            {...(navigateTo && {
                component: Link,
                to: navigateTo,
            })}
            {...rest}
            ref={ref}
            color="primary"
            variant={variant}
            size={size}
            ownerState={{ color, variant, size, circular, iconOnly }}
        >
            {children}
        </SuiButtonRoot>
    ),
);

// Setting default values for the props of SuiButton
SuiButton.defaultProps = {
    size: 'medium',
    variant: 'contained',
    color: 'white',
    circular: false,
    iconOnly: false,
};

export default SuiButton;
